export default () => ['bold', 'italic', 'blockquote', 'link', 'file', 'emoji'];
